import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be11c238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title my-3 my-lg-5" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "description padd-button" }
const _hoisted_6 = { class: "description" }

import { translate } from '@/languages/i18n'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  while (modalBackdrop.length > 0) {
    modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('zz15_500_title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('zz15_500_content1')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('zz15_500_content2')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('zz15_500_content3')), 1)
    ])
  ]))
}
}

})